"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeBtnPosition = exports.closeBtnIcon = exports.closeBtn = exports.PopupBody = exports.PopupHeader = exports.PopupHeaderWrapper = exports.PopupContent = exports.PopupContainer = exports.PopupWrapper = exports.PopupBackDrop = exports.PopupType = void 0;
var PopupType;
(function (PopupType) {
    PopupType["DEFAULT"] = "default";
    PopupType["MEDIA"] = "media";
    PopupType["SINGLE_MEDIA"] = "single_media";
    PopupType["VIDEO"] = "video";
    PopupType["FORM"] = "form";
    PopupType["REDIRECT"] = "redirect";
})(PopupType || (exports.PopupType = PopupType = {}));
/**
 * Popup wrapper class.
 */
exports.PopupBackDrop = {
    [PopupType.DEFAULT]: 'bg-overlay-primary fixed inset-0 transition-opacity z-[11]',
    [PopupType.MEDIA]: 'bg-overlay-primary fixed inset-0 transition-opacity z-[11]',
    [PopupType.SINGLE_MEDIA]: 'bg-overlay-primary fixed inset-0 transition-opacity z-[11]',
    [PopupType.VIDEO]: 'bg-overlay-primary fixed inset-0 transition-opacity z-[11]',
    [PopupType.FORM]: 'bg-overlay-primary fixed inset-0 transition-opacity z-[11]',
    [PopupType.REDIRECT]: 'bg-overlay-primary fixed inset-0 opacity-75 pointer-events-none transition-opacity z-[11]',
};
/**
 * Popup wrapper class.
 */
exports.PopupWrapper = {
    [PopupType.DEFAULT]: 'fixed inset-0 block mx-auto max-h-full max-w-full min-h-[50%] min-w-[50%] outline-none overflow-x-hidden overflow-y-auto md:px-6 z-[12]',
    [PopupType.MEDIA]: 'fixed inset-0 block mx-auto max-h-full max-w-full min-h-[50%] min-w-[50%] outline-none overflow-x-hidden overflow-y-auto md:px-6 z-[12]',
    [PopupType.SINGLE_MEDIA]: 'fixed inset-0 block mx-auto max-h-full max-w-full min-h-[50%] min-w-[50%] outline-none overflow-x-hidden overflow-y-auto md:px-6 z-[12]',
    [PopupType.VIDEO]: 'fixed inset-0 block mx-auto max-h-full max-w-full min-h-[50%] min-w-[50%] outline-none overflow-x-hidden overflow-y-auto md:px-6 z-[12]',
    [PopupType.FORM]: 'fixed inset-0 block mx-auto max-h-full max-w-full min-h-[50%] min-w-[50%] outline-none overflow-x-hidden overflow-y-auto md:px-6 z-[12]',
    [PopupType.REDIRECT]: 'fixed inset-0 overflow-y-auto z-[30]',
};
/**
 * Popup container class.
 */
exports.PopupContainer = {
    [PopupType.DEFAULT]: 'lg:mt-6! top-0! transform-none! flex flex-col items-center px-3 z-[6]',
    [PopupType.REDIRECT]: 'flex min-h-full items-start justify-center p-xs sm:p-md',
    [PopupType.MEDIA]: 'lg:mt-6! top-0! transform-none! flex flex-col items-center px-3 z-[6]',
    [PopupType.SINGLE_MEDIA]: 'lg:mt-6! top-0! transform-none! flex flex-col items-center px-3 z-[6]',
    [PopupType.VIDEO]: 'lg:mt-6! top-0! transform-none! flex flex-col items-center px-3 z-[6]',
    [PopupType.FORM]: 'lg:mt-12! top-0! transform-none! flex flex-col items-center px-3 z-[6]',
};
/**
 * Popup content class.
 */
exports.PopupContent = {
    [PopupType.DEFAULT]: '',
    [PopupType.MEDIA]: 'max-sm:h-screen max-w-[876px] md:pl-[50px] relative popup-content w-full lg:max-w-[900px] md:p-4 lg:p-12 lg:pt-6 outline-none rounded-lg',
    [PopupType.SINGLE_MEDIA]: 'max-w-[876px] w-full lg:max-w-[900px] relative max-sm:mt-[9%] max-xl:mt-[3%]',
    [PopupType.VIDEO]: 'max-w-[876px] w-full lg:max-w-[900px] relative',
    [PopupType.FORM]: 'bg-white w-[876px] lg:max-w-[876px] p-4 sm:p-12 max-sm:pt-6 max-md:w-full relative outline-none rounded-3xl max-lg:mt-6 sm:pt-7!',
    [PopupType.REDIRECT]: 'bg-surface-primary border-primary rounded-3xl border relative shadow-xl sm:w-[596px] top-[130px] sm:top-[239px]',
};
exports.PopupHeaderWrapper = {
    [PopupType.DEFAULT]: 'max-md:mb-4 mb-6',
    [PopupType.MEDIA]: 'max-md:mb-4 mb-6',
    [PopupType.SINGLE_MEDIA]: 'max-md:mb-2 mb-3',
    [PopupType.VIDEO]: 'max-md:mb-2 mb-3',
    [PopupType.FORM]: 'max-md:mb-4 mb-6',
    [PopupType.REDIRECT]: 'gap-2xs pl-md sm:pl-4xl flex flex-row-reverse items-start justify-between',
};
exports.PopupHeader = {
    [PopupType.MEDIA]: 'popup-title text-2xl leading-9 text-primary max-w-[85%]',
    [PopupType.SINGLE_MEDIA]: 'popup-title text-2xl leading-9 text-primary max-w-[85%]',
    [PopupType.VIDEO]: 'popup-title text-2xl leading-9 text-primary max-w-[85%]',
    [PopupType.FORM]: 'popup-title text-2xl leading-9 text-primary max-w-[85%]',
    [PopupType.DEFAULT]: 'popup-title text-2xl leading-9 text-primary max-w-[85%]',
    [PopupType.REDIRECT]: 'heading-sm sm:heading-md pt-2xl sm:pt-4xl sm:pb-2xl pb-md'
};
exports.PopupBody = {
    [PopupType.MEDIA]: 'popup-body flex flex-wrap gap-2xl',
    [PopupType.SINGLE_MEDIA]: 'popup-body flex flex-wrap gap-2xl',
    [PopupType.VIDEO]: 'popup-body flex flex-wrap gap-2xl',
    [PopupType.FORM]: 'popup-body flex flex-wrap gap-2xl',
    [PopupType.DEFAULT]: 'popup-body flex flex-wrap gap-2xl',
    [PopupType.REDIRECT]: 'flex px-md sm:pb-4xl sm:pt-3xl sm:px-4xl py-2xl justify-end gap-md flex-col sm:flex-row items-center',
};
exports.closeBtn = {
    [PopupType.MEDIA]: '',
    [PopupType.SINGLE_MEDIA]: '',
    [PopupType.VIDEO]: '',
    [PopupType.FORM]: '',
    [PopupType.DEFAULT]: '',
    [PopupType.REDIRECT]: 'text-icon-primary mt-2xs sm:mt-2xl mr-2xs sm:mr-2xl bg-fill-primary p-2xs hover:bg-fill-primary-hovered active:bg-fill-primary-pressed rounded-full',
};
exports.closeBtnIcon = {
    [PopupType.MEDIA]: 'bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed p-2xs absolute rounded-full hover:cursor-pointer',
    [PopupType.SINGLE_MEDIA]: 'bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed p-2xs absolute rounded-full hover:cursor-pointer',
    [PopupType.VIDEO]: 'bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed p-2xs absolute rounded-full hover:cursor-pointer',
    [PopupType.FORM]: 'bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed p-2xs absolute rounded-full hover:cursor-pointer',
    [PopupType.DEFAULT]: 'bg-fill-secondary hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed p-2xs absolute rounded-full hover:cursor-pointer',
    [PopupType.REDIRECT]: '',
};
exports.closeBtnPosition = {
    [PopupType.DEFAULT]: 'top-[-22px]! right-[1%]! z-[99]',
    [PopupType.MEDIA]: 'top-[60px]! right-[9%]! z-[99] max-sm:top-[29vh]! max-sm:right-[12%]! max-[450px]:top-[33vh]! max-[450px]:right-[17%]!',
    [PopupType.SINGLE_MEDIA]: 'top-[-22px]! right-[1%]! z-[99]',
    [PopupType.VIDEO]: 'top-[-22px]! right-[6%]! z-[99]',
    [PopupType.FORM]: 'top-[10px] right-[-15px] max-sm:right-[-5px]',
    [PopupType.REDIRECT]: '',
};
